export const loginContainer = 'p-4 z-10';
export const wrapper = 'min-h-full bg-white flex flex-1 flex-col';
